<template>
  <div>
    <v-dialog v-model="dialog" width="800">
      <template v-slot:activator="{ on, attrs }">
        <v-btn text color="primary" dark v-bind="attrs" v-on="on">
          คำนวณขั้นสูง
        </v-btn>
      </template>
      <v-card flat tile>
        <v-card-title>คำนวณขั้นสูง</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div v-if="Object.keys(GroupedData.grouped).length > 0">
            <div class="my-3 black--text">
              <h4>จำนวนแบบสอบถาม: {{ GroupedData.q_count }} ข้อ</h4>
              <h4>จำนวนครั้งที่ทำแบบสอบถาม: {{ Alldata.length }} ครั้ง</h4>
              <h4>
                คะแนนทั้งหมด:
                {{
                  AllScore(
                    Object.keys(GroupedData.grouped),
                    Object.values(GroupedData.grouped)
                  )
                }}
                คะแนน
              </h4>
              <h4>
                คะแนนเฉลี่ย:
                {{
                  AvgCal(
                    Object.keys(GroupedData.grouped),
                    Object.values(GroupedData.grouped)
                  )
                }}
              </h4>
              <br />
              คะแนน
              <v-card v-for="(n, i) in GroupedData.grouped" :key="i" flat
                >{{ i }} คะแนน: {{ n }} คำตอบ
              </v-card>
              <br />
            </div>
            <v-form ref="form">
              <v-row>
                <v-col cols="12"><h4>การตั้งค่าการคำนวณ</h4></v-col>
                <v-col cols="12"
                  ><v-alert
                    class="elevation-2 rounded-lg"
                    prominent
                    v-for="(condition, i) in creterias"
                    :key="i"
                  >
                    <v-container>
                      <v-row align="center">
                        <v-col class="grow">
                          <v-row align="center">
                            <v-col cols="12" md="6" class="d-flex align-center">
                              <v-select
                                v-model="condition.number.operation"
                                :items="operationlist"
                                label="เลือกเงื่อนไข"
                                class="mr-2"
                                solo
                                dense
                                color="#0D8EEE"
                                item-value="operation"
                                item-text="text"
                                :error="condition.errorLabel"
                                :error-messages="condition.errorLabelMsg"
                                @input="CheckNumber(i)"
                                :rules="[
                                  $store.getters.TextRule(
                                    condition.number.operation
                                  ),
                                ]"
                                style="max-width: 160px"
                              ></v-select>
                              <div
                                v-if="
                                  condition.number.operation === '><' ||
                                  condition.number.operation === '<>'
                                "
                                class="d-flex"
                              >
                                <v-text-field
                                  v-model="condition.number.value_from"
                                  type="number"
                                  solo
                                  dense
                                  label="คะแนน"
                                  class="mr-2"
                                  :error="condition.errorLabel"
                                  :error-messages="condition.errorLabelMsg"
                                  @input="CheckNumber(i)"
                                  :rules="[
                                    $store.getters.ScoreRule(
                                      condition.number.value_from
                                    ),
                                  ]"
                                  style="max-width: 80px"
                                >
                                </v-text-field>
                                <v-text-field
                                  v-model="condition.number.value_to"
                                  type="number"
                                  solo
                                  dense
                                  label="คะแนน"
                                  class="mr-2"
                                  :error="condition.errorLabel"
                                  :error-messages="condition.errorLabelMsg"
                                  @input="CheckNumber(i)"
                                  :rules="[
                                    $store.getters.ScoreRule(
                                      condition.number.value_to
                                    ),
                                  ]"
                                  style="max-width: 80px"
                                >
                                </v-text-field>
                              </div>
                              <div v-else>
                                <v-text-field
                                  v-model="condition.number.value"
                                  type="number"
                                  solo
                                  dense
                                  label="คะแนน"
                                  class="mr-2"
                                  :error="condition.errorLabel"
                                  :error-messages="condition.errorLabelMsg"
                                  @input="CheckNumber(i)"
                                  :rules="[
                                    $store.getters.ScoreRule(
                                      condition.number.value
                                    ),
                                  ]"
                                  style="max-width: 120px"
                                >
                                </v-text-field>
                              </div>
                            </v-col>
                            <v-col cols="12" md="6" class="d-flex align-center">
                              <v-text-field
                                v-model="condition.conditiontext"
                                solo
                                dense
                                :disabled="condition.errorLabel"
                                :rules="[
                                  $store.getters.TextRule(
                                    condition.conditiontext
                                  ),
                                ]"
                                style="width: 30px"
                              >
                                <template #prepend> คำจำกัดความ </template>
                              </v-text-field>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col
                          class="shrink d-flex align-center"
                          :style="{
                            visibility:
                              Object.keys(creterias).length > 1
                                ? 'visible'
                                : 'hidden',
                          }"
                        >
                          <v-btn
                            color="#DE4F3B"
                            icon
                            @click="$delete(creterias, i)"
                            ><v-icon>mdi-trash-can-outline </v-icon></v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-container> </v-alert
                  ><v-row>
                    <v-col cols="12" class="d-flex justify-center">
                      <v-btn color="#0278ae" dark fab @click="AddCondition">
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row></v-col
                >
                <v-col cols="12"
                  ><v-btn color="success" @click="Calculate"
                    >แสดงผล</v-btn
                  ></v-col
                >
              </v-row>
            </v-form>
          </div>
          <div v-else>ไม่มีข้อมูลในช่วงเวลานี้</div>
        </v-card-text>
        <v-divider></v-divider>
      </v-card>
      <v-row
        no-gutters
        style="width: 100%"
        v-if="
          Object.keys(GroupedData.grouped).length > 0 &&
          Object.keys(Advand_pie.data[0].data).length > 0
        "
      >
        <v-col cols="12">
          <v-card flat tile>
            <v-card-title primary-title
              ><v-spacer></v-spacer>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="#033666"
                    class="mx-2"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    <span style="font-size: 12px"> Chart</span>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item, index) in advand"
                    :key="index"
                    @click="AdvandChartChange(item)"
                  >
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="letter-spacing: 0; width: 100%">
              <Pie
                v-if="advand_selected === 'pie'"
                :title="$route.params.surveyName"
                :data="Advand_pie"
              />
              <SingleBarChart
                v-if="advand_selected === 'column'"
                :title="$route.params.surveyName"
                :data="Advand_pie"
              />
            </v-card-text> </v-card
        ></v-col>
      </v-row>
      <v-card flat tile>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import _ from "lodash";
import SingleBarChart from "../../components/Dashboard/Chart/SingleBarChart.vue";
import Pie from "../../components/Dashboard/Chart/Pie.vue";
export default {
  props: ["Alldata", "storeQuestion"],
  components: { Pie, SingleBarChart },
  data() {
    return {
      dialog: false,
      condition: 0,
      creterias: [
        {
          conditiontext: null,
          conditiontype: "number",
          number: { operation: null, value: 0, value_from: 0, value_to: 0 },
          errorLabel: false,
          errorLabelMsg: "",
        },
      ],
      Advand_pie: {
        pointFormat: "{point.name}: <b>{point.y} ครั้ง</b>",
        colors: [],
        data: [
          {
            name: "คะแนน",
            colorByPoint: true,
            data: [],
          },
        ],
      },
      advand_selected: "pie",
      advand: [
        { title: "Pie Chart", value: "pie" },
        { title: "Bar Chart", value: "column" },
      ],
    };
  },
  computed: {
    GroupedData() {
      let allans = [];
      let allq = [];
      for (const key in this.Alldata) {
        if (Object.hasOwnProperty.call(this.Alldata, key)) {
          const element = this.Alldata[key];
          allans.push(element.score);
          for (const obj_key in element) {
            if (Object.hasOwnProperty.call(element, obj_key)) {
              // const obj_element = element[obj_key];
              let isq = this.storeQuestion.find(
                (qid) => qid.questionID === obj_key
              );
              if (isq) {
                let exist_q = allq.find((ex_qid) => ex_qid === isq.questionID);
                if (!exist_q) {
                  allq.push(isq.questionID);
                }
              }
            }
          }
        }
      }
      var result = _.countBy(allans);
      return { grouped: { ...result }, q_count: allq.length };
    },
    operationlist() {
      return this.$store.state.operation;
    },
  },
  methods: {
    AllScore(arrValues, arrWeights) {
      const result = arrValues
        .map((value, i) => {
          const weight = arrWeights[i];
          const sum = value * weight;
          return [sum, weight];
        })
        .reduce((p, c) => [p[0] + c[0], p[1] + c[1]], [0, 0]);

      return result[0];
    },
    AvgCal(arrValues, arrWeights) {
      const result = arrValues
        .map((value, i) => {
          const weight = arrWeights[i];
          const sum = value * weight;
          return [sum, weight];
        })
        .reduce((p, c) => [p[0] + c[0], p[1] + c[1]], [0, 0]);

      return (result[0] / result[1]).toFixed(2);
    },
    AdvandChartChange(chart) {
      switch (chart.value) {
        case "pie":
          {
            this.advand_selected = "pie";
          }

          break;
        case "column":
          {
            this.advand_selected = "column";
          }

          break;
      }
    },
    Calculate() {
      if (this.$refs.form.validate()) {
        this.Advand_pie.data[0].data = [];
        let data = [];
        this.creterias.map((d) => {
          // console.log(d);
          // console.log(this.GroupedData);
          let score = d.number.value;
          let rangescore = [d.number.value_from, d.number.value_to];
          let sumdata = 0;
          let operation = d.number.operation;
          for (const key in this.GroupedData.grouped) {
            if (Object.hasOwnProperty.call(this.GroupedData.grouped, key)) {
              const element = this.GroupedData.grouped[key];
              // console.log(`${key}: ${element}`);
              switch (operation) {
                case "<":
                  {
                    if (+key < +score) {
                      sumdata += +element;
                    }
                  }

                  break;
                case "<=":
                  {
                    if (+key <= +score) {
                      sumdata += +element;
                    }
                  }

                  break;
                case ">":
                  {
                    if (+key > +score) {
                      sumdata += +element;
                    }
                  }

                  break;
                case ">=":
                  {
                    if (+key >= +score) {
                      sumdata += +element;
                    }
                  }

                  break;
                case "==":
                  {
                    if (+key == +score) {
                      sumdata += +element;
                    }
                  }

                  break;
                case "!=":
                  {
                    if (+key != +score) {
                      sumdata += +element;
                    }
                  }

                  break;
                case "><":
                  {
                    if (+key >= +rangescore[0] && +key <= +rangescore[1]) {
                      sumdata += +element;
                    }
                  }

                  break;
                case "<>":
                  {
                    if (!(+key >= +rangescore[0] && +key <= +rangescore[1])) {
                      sumdata += +element;
                    }
                  }

                  break;
              }
            }
          }
          data.push({
            name: d.conditiontext,
            y: sumdata,
          });
        });
        // console.log(data);
        this.Advand_pie.data[0].data = data;
      }
    },
    AddCondition() {
      this.creterias.push({
        conditiontext: null,
        conditiontype: "number",
        number: { operation: "", value: 0, value_from: 0, value_to: 0 },
        errorLabel: false,
        errorLabelMsg: "",
      });
    },
    CheckAllNumber() {
      this.creterias.map((item) => {
        item.numbertext = `${item.number.operation}|${
          item.number.operation === "><" || item.number.operation === "<>"
            ? `${item.number.value_from}|${item.number.value_to}`
            : item.number.value
        }`;
        item.errorLabel = false;
        item.errorLabelMsg = "";
      });
      const counts = _.countBy(this.creterias, "numbertext");
      let dup = _.filter(this.creterias, (x) => counts[x.numbertext] > 1);
      if (dup.length > 1) {
        dup.map((item) => {
          if (item.numbertext) {
            item.errorLabel = true;
            item.errorLabelMsg = "มีเงื่อนไขนี้แล้ว";
          }
        });
      }
    },
    CheckNumber: _.debounce(function () {
      this.creterias.map((item) => {
        item.numbertext = `${item.number.operation}|${
          item.number.operation === "><" || item.number.operation === "<>"
            ? `${item.number.value_from}|${item.number.value_to}`
            : item.number.value
        }`;
        item.errorLabel = false;
        item.errorLabelMsg = "";
      });
      const counts = _.countBy(this.creterias, "numbertext");
      let dup = _.filter(this.creterias, (x) => counts[x.numbertext] > 1);
      if (dup.length > 1) {
        dup.map((item) => {
          if (item.numbertext && item.number.operation) {
            item.errorLabel = true;
            item.errorLabelMsg = "มีเงื่อนไขนี้แล้ว";
          }
        });
      }
    }, 0),
  },
};
</script>
